import { isEmpty } from '../../../utils'

// props
export const textAreaProps = {
  value: {
    type: [Number, String],
    default: ''
  },
  size: {
    type: String,
    default: 'small'
  },
  // 最大长度
  maxLength: {
    type: Number,
    default: 50
  },
  // 最小长度
  minLength: {
    type: Number
  },
  //
  autosize: {
    type: [Object, Boolean],
    default: () => ({
      minRows: 1,
      maxRows: 4
    })
  },
  placeholder: {
    type: String,
    default: ''
  },
  // 显示
  showLength: {
    type: Boolean,
    default: true
  },

  // 是否显示tip
  showTooltip: {
    type: Boolean,
    default: true
  },

  // 展示内容
  tip: {
    type: String,
    default: ''
  },

  // 行数量
  line: {
    type: Number,
    default: 2
  },

  openDelay: {
    type: Number,
    default: 500
  },

  // 只读
  disabled: {
    type: Boolean,
    default: false
  },

  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  }
}

export function initValue (value) {
  return isEmpty(value) ? '-' : value
}